import { useQuery } from 'react-query'
import MmsService from 'Services/MMS/mms-api.service'

export const useFleetDepartments = (companyId) => {
  return useQuery(
    ['departments', 'fleet', companyId],
    async () => {
      const response = await MmsService.getDepartmentsWithFleetType(companyId)
      return response?.data || []
    },
    {
      enabled: !!companyId,
      refetchOnWindowFocus: false,
    }
  )
}

export default useFleetDepartments
